import { Id } from "components/kanbanBoard/types.ts";

export enum StartActionType {
  POST = 'post',
  GET = 'get',
  HREF = 'href',
  INFO = 'info'
}

export enum TaskPriority {
  LOW = 0,
  MEDIUM = 1,
  HIGH = 2,
  URGENT = 3
}

export type StartAction = {
  id: number;
  type: StartActionType;
  content: string | null;
  responseType: string | null;
  body: string | null;
}


export type TaskLabels = {
  id: Id;
  name: TaskLabel;
};

export enum TaskLabel {
  GENERAL = 'algemeen',
  LEGAL = 'juridisch',
  FINANCE = 'financieel',
  CUSTOMER_SUPPORT = 'klanten support',
  RENOVATION = 'renovaties',
  MAINTENANCE = 'onderhoud',
  IT = 'it',
  BOARD = 'raad van bestuur',
  ACQUISITION = 'acquisitie',
  DUE_DIL = 'due diligence',
  MARKETING = 'marketing',
  INSURANCES = 'verzekeringen',
  RENT = 'verhuur'
}

export enum TaskPhase {
  INBOX = 'inbox',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  THIS_WEEK = 'this week',
  NEXT_WEEK = 'next week',
  LATER = 'later',
  REVIEW = 'review',
  VALIDATED = 'validated',
  REMARKS = 'remarks',
  IDEAS = 'ideas',
  DONE = 'done'
}


export type TaskAttachment = {
    id: Id;
    fileName: string;
    sharePointFileUrl: string;
    sharePointFolderUrl: string;
    sharePointFileId: string;
    sharePointFolderId: string;
}


export type Task = {
  id: number;
  phase: TaskPhase;
  description: string;
  title: string;
  deadline: any;
  inPhaseSince: any;
  labels: TaskLabels[];
  priority: TaskPriority;
  resources: any[];
  assignedBy: any;
  completed: boolean;
  completedAt: any;
  assignee: any;
  sharePointFolderId: string;
  sharePointFolderUrl: string;
  attachments: TaskAttachment[];
};